module.exports = __webpack_public_path__ + "static/img-duotono@3x-b5196e2cccf945bff6f9725d20a3284b.png";